import { ITask } from "@/api/tasks/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjectsData } from "@/api/projects/types";

export interface IProjectsResponse {
  success: boolean;
  message: string;
  data: IProjectsData[];
}

export const initialProject = {
  id: 0,
  name: '',
  description: '',
  startDate: '',
  endDate: '',
  idStatus: 1,
  idCompany: 0
};

interface ProjectsState {
  projects: IProjectsData[];
  message: string;
  success: boolean;
  sectionModalState: {
    show: boolean;
    id?: string;
    sectionData?: {
      title: string;
      description: string;
    }
  };
  projectModalState: {
    show: boolean;
    project: {
      id: number;
      name: string;
      description: string;
      startDate: string;
      endDate: string;
      idStatus: number;
      idCompany: number;
    }
  };
  draggingTaskPositions: { [key: string]: ITask[] };
}

const initialState: ProjectsState = {
  projects: [],
  message: "",
  success: false,
  sectionModalState: {
    show: false,
    id: undefined,
    sectionData: {
      title: "",
      description: "",
    }
  },
  projectModalState: {
    show: false,
    project: {
      id: 0,
      name: '',
      description: '',
      startDate: '',
      endDate: '',
      idStatus: 1,
      idCompany: 0
    }
  },
  draggingTaskPositions: {},
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    loadProjects: (state, action: PayloadAction<IProjectsResponse>) => {
      state.projects = action.payload.data || [];
      state.message = action.payload.message || "";
      state.success = action.payload.success || false;
    },
    showCreateUpdateSection: (
      state,
      action: PayloadAction<{
        id?: number;
        title?: string;
        description?: string;
      }>
    ) => {
      state.sectionModalState.show = true;
      state.sectionModalState.id = action.payload?.id?.toString() ?? undefined;
      state.sectionModalState.sectionData = {
        title: action.payload?.title || "",
        description: action.payload?.description || ""
      };
    },
    closeCreateUpdateSection: (state) => {
      state.sectionModalState.show = false;
      state.sectionModalState.id = undefined;
      state.sectionModalState.sectionData = {
        title: "",
        description: ""
      };
    },
    disMissProjects: (state) => {
      state.projects = [];
      state.message = "";
      state.success = false;
    },
    showCreateUpdateProjectModal: (
      state,
      action: PayloadAction<{ project: IProjectsData }>
    ) => {
      state.projectModalState.show = true;
      state.projectModalState.project = action.payload.project;
    },
    closeCreateUpdateProjectModal: (state) => {
      state.projectModalState.show = false;
      state.projectModalState.project = {
        id: 0,
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        idStatus: 1,
        idCompany: 0
      };
    },
    setDraggingTaskPositions: (
      state,
      action: PayloadAction<{ [key: string]: ITask[] }>,
    ) => {
      state.draggingTaskPositions = action.payload;
    }
  }
})

export const {
  closeCreateUpdateProjectModal,
  closeCreateUpdateSection,
  loadProjects,
  disMissProjects,
  showCreateUpdateProjectModal,
  showCreateUpdateSection,
  setDraggingTaskPositions,
} = projectsSlice.actions;

export default projectsSlice.reducer;

